import React, { useState } from 'react';
import faqData from '../data/faqs.json';

function FAQ() {
  const [openQuestion, setOpenQuestion] = useState(null);
  const { hero, intro, categories, cta } = faqData;

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenQuestion(openQuestion === key ? null : key);
  };

  const renderAnswer = (answer) => {
    if (!Array.isArray(answer)) return answer;

    return answer.map((part, index) => (
      part.href
        ? <a key={index} href={part.href}>{part.text}</a>
        : <React.Fragment key={index}>{part.text}</React.Fragment>
    ));
  };

  return (
    <div className="fade-in">
      <div className="hero">
        <h1>{hero.title}</h1>
        <p>{hero.subtitle}</p>
      </div>

      <div className="content-section container">
        <h2>{intro.title}</h2>
        <p style={{ textAlign: 'center', fontSize: '1.1rem', marginBottom: '3rem' }}>
          {intro.text}{' '}
          <a href={intro.link.to} style={{ color: '#FF9933', fontWeight: 'bold' }}>{intro.link.label}</a>.
        </p>

        <div className="faq-container">
          {categories.map((category, catIndex) => (
            <div key={category.category} className="faq-category">
              <h3 className="faq-category-title">
                <span className="faq-category-icon">📋</span>
                {category.category}
              </h3>
              {category.questions.map((item, qIndex) => {
                const key = `${catIndex}-${qIndex}`;
                const isOpen = openQuestion === key;

                return (
                  <div key={item.q} className="faq-item">
                    <button
                      className={`faq-question ${isOpen ? 'active' : ''}`}
                      onClick={() => toggleQuestion(catIndex, qIndex)}
                      aria-expanded={isOpen}
                      aria-controls={`faq-answer-${key}`}
                    >
                      <span>{item.q}</span>
                      <span className="faq-toggle">{isOpen ? '-' : '+'}</span>
                    </button>
                    {isOpen && (
                      <div id={`faq-answer-${key}`} className="faq-answer">
                        <p>{renderAnswer(item.a)}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      <div className="content-section container" style={{ textAlign: 'center', background: 'linear-gradient(135deg, #FFF5E6 0%, #FFE8CC 100%)', padding: '3rem', borderRadius: '10px' }}>
        <h2 style={{ color: '#FF9933' }}>{cta.title}</h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '2rem' }}>
          {cta.text}
        </p>
        {cta.links.map((link, index) => (
          <a
            key={link.to}
            href={link.to}
            className={link.className}
            style={index === 0 ? { marginRight: '1rem' } : undefined}
          >
            {link.label}
          </a>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
